export { Ng2ImgMaxService } from './src/ng2-img-max.service';
export { Ng2ImgMaxModule } from './src/ng2-img-max.module';
export { ImgMaxSizeService } from './src/img-max-size.service';
export { ImgMaxPXSizeService } from './src/img-maxpx-size.service';
export { ImgExifService } from './src/img-exif.service';
//# sourceMappingURL=ng2-img-max.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-max/dist/ng2-img-max.js
// module id = ./node_modules/ng2-img-max/dist/ng2-img-max.js
// module chunks = 0